module.exports = __webpack_public_path__ + "img/kulioner-must-buy.ab9a7cf8.svg";